import store from '../store'

export default function FavoritesMiddleware({ next, router }) {
  if(!store.state.favorites.length){
    router.back()
  }
  return next();
}
